import { render } from "./NameDialog.vue?vue&type=template&id=a1d2ecde"
import script from "./NameDialog.vue?vue&type=script&lang=js"
export * from "./NameDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\miao-up-up-mobile-spa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__